import store from '@/store'

export default (to, from, next) => ({
    allow: store.getters.isModuleAvailable('SVC_MATRIXX'),
    redirect: { name: 'main-dashboard' }
})